import * as TemplateService from "../../secure/services/templateService";
import { put, takeEvery } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/emsActions";
import * as actionsLoader from "../actions/loaderActions";
import * as UtilsHelper from "../../../utils/utilsHelper";
import i18n from "i18next";
import _ from "underscore";
import AzureFileuploadHelper from "../../../utils/azureFileuploadHelper";

export function* generateCompleteAuditTrailSaga(data) {
  try {
    const response = yield TemplateService.doCompleteAuditTrail(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      // eslint-disable-next-line no-unused-vars
      const { archiveId, status } = result;
      if (!_.isEmpty(archiveId)) {
        yield put(actions.statusCompleteAuditTrail(result));
      } else {
        yield put(actions.generateCompleteAuditTrailFailed());
      }
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.generateCompleteAuditTrailFailed(errorMessage));
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(
      actionsLoader.showError(
        i18n.t("ARCHIVE.TOAST_GENERATESOMETHINGWENTWRONG"), "error", "warning"
      )
    );
  }
}

export function* getCompleteAuditTrailSagas(data) {
  const category = data.payload
  try {
    const response = yield TemplateService.doFetchAuditTrailDetail(category);
    const { isError, result } = response.data;
    if (!isError) {
      const { live, latest } = result;
      yield put(actions.getCompleteAuditTrailSuccess(latest, _.isEmpty(live)));
      if (!_.isEmpty(live)) {
        const reqPayload = {
          archiveId: live.id,
        };
        yield put(actions.statusCompleteAuditTrail(reqPayload));
      }
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.getCompleteAuditTrailFailed(errorMessage));
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(
      actionsLoader.showError(
        i18n.t("ARCHIVE.TOAST_GENERATESOMETHINGWENTWRONG"), "error", "warning"
      )
    );
  }
}

export function* statusCompleteAuditTrailSaga(data) {
  const { archiveId } = data.payload;
  try {
    if (!_.isEmpty(archiveId)) {
      const response = yield TemplateService.doFetchStatusAuditTrail(archiveId);
      const { isError, result } = response.data;
      if (!isError) {
        yield put(
          actions.generateCompleteAuditTrailSuccess({
            ...data.payload,
            ...result,
          })
        );
      } else {
        const errorMessage = UtilsHelper.constructErrorMsg(response.data);
        yield put(actions.generateCompleteAuditTrailFailed(errorMessage));
        yield put(actionsLoader.showError(errorMessage, "error", "warning"));
      }
    }
  } catch (error) {
    yield put(
      actionsLoader.showError(
        i18n.t("ARCHIVE.TOAST_GENERATESOMETHINGWENTWRONG"), "error", "warning"
      )
    );
  }
}

export function* cancelCompleteAuditTrailSaga(data) {
  try {
    const response = yield TemplateService.doCancelAuditTrail(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      if (data.isStatus) yield put(actions.statusCompleteAuditTrail(result));
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.generateCompleteAuditTrailFailed(errorMessage));
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(
      actionsLoader.showError(
        i18n.t("ARCHIVE.TOAST_GENERATESOMETHINGWENTWRONG"), "error", "warning"
      )
    );
  }
}

export function* downloadCompleteAuditTrailSaga(data) {
  try {
    let validFilename = UtilsHelper.fileInvalidCharsRemoval(
      data.payload.filename
    );
    data.payload.friendlyFileName = validFilename;
    const response = yield TemplateService.doDownloadAuditTrail(data.payload);
    const { isError, result } = response.data;

    if (!isError) {
      let fileurl = atob(result.sastoken);
      const { filename } = data.payload;
      yield AzureFileuploadHelper.downloadAzureFile(fileurl, {
        downloadFileName: UtilsHelper.fileExtensionRemoval(filename),
        type: UtilsHelper.getFileExtension(filename),
      });
      yield put(actions.downloadCompleteAuditTrailSuccess(data.payload.id));
      // yield AzureFileuploadHelper.downloadAzureFile(fileurl);
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(
        actions.downloadCompleteAuditTrailFailed(errorMessage, data.payload.id)
      );
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
    }
  } catch (error) {
    yield put(
      actionsLoader.showError(
        i18n.t("ARCHIVE.TOAST_GENERATESOMETHINGWENTWRONG"), "error", "warning"
      )
    );
  }
}

export function* emsTemplateAsync() {
  yield takeEvery(
    `${actionTypes.GET_COMPLETE_EMS_TRAIL}_INITIAL`,
    getCompleteAuditTrailSagas
  );

  yield takeEvery(
    actionTypes.GENERATE_COMPLETE_EMS_TRAIL,
    generateCompleteAuditTrailSaga
  );
  yield takeEvery(
    `${actionTypes.GENERATE_COMPLETE_EMS_TRAIL}_STATUS`,
    statusCompleteAuditTrailSaga
  );
  yield takeEvery(
    `${actionTypes.GENERATE_COMPLETE_EMS_TRAIL}_CANCEL`,
    cancelCompleteAuditTrailSaga
  );
  yield takeEvery(
    actionTypes.DOWNLOAD_COMPLETE_EMS_TRAIL,
    downloadCompleteAuditTrailSaga
  );
}
